// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-AccountSetting-Receipt-ReceiptForm-__ReceiptForm___375xp","footer":"app-pages-AccountSetting-Receipt-ReceiptForm-__ReceiptForm___G4uKO","field-wrapper":"app-pages-AccountSetting-Receipt-ReceiptForm-__ReceiptForm___2ONKd","custom-receipt":"app-pages-AccountSetting-Receipt-ReceiptForm-__ReceiptForm___23ugC"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/Receipt/ReceiptForm/ReceiptForm.css
// module id = 2290
// module chunks = 0